(function () {
  var FLOOR = 12;

  function fitOne(h) {
    h.style.fontSize = '';
    var size = parseFloat(getComputedStyle(h).fontSize);
    if (!size) return FLOOR;
    var guard = 48;
    while (h.scrollWidth > h.clientWidth && size > FLOOR && guard-- > 0) {
      size -= 1;
      h.style.fontSize = size + 'px';
    }
    return size;
  }

  function fitSection(sec) {
    var headings = [].slice.call(sec.querySelectorAll('.card-wrapper .card__heading'));
    if (!headings.length) return;
    var min = Infinity;
    headings.forEach(function (h) { min = Math.min(min, fitOne(h)); });
    headings.forEach(function (h) { h.style.fontSize = min + 'px'; });
  }

  var pending = new WeakSet();
  function schedule(sec) {
    if (pending.has(sec)) return;
    pending.add(sec);
    requestAnimationFrame(function () {
      pending.delete(sec);
      fitSection(sec);
    });
  }

  function fitAll() {
    document.querySelectorAll('.th-recipes').forEach(schedule);
  }

  function updateSwipers() {
    document.querySelectorAll('.th-recipes swiper-container').forEach(function (sc) {
      if (sc.shadowRoot) {
        var sd = sc.shadowRoot.querySelector('.swiper');
        if (sd) {
          sd.style.setProperty('padding-left', '0', 'important');
          sd.style.setProperty('padding-right', '0', 'important');
        }
        var sw = sc.shadowRoot.querySelector('.swiper-wrapper');
        if (sw) sw.style.setProperty('padding-top', '0', 'important');
      }
      if (sc.swiper && sc.swiper.update) sc.swiper.update();
    });
  }

  function init() {
    updateSwipers();
    fitAll();
    if (window.ResizeObserver) {
      document.querySelectorAll('.th-recipes').forEach(function (sec) {
        var ro = new ResizeObserver(function () { schedule(sec); });
        sec.querySelectorAll('.card-wrapper .card__information').forEach(function (row) { ro.observe(row); });
        var sc = sec.querySelector('swiper-container');
        if (sc) {
          new ResizeObserver(function () {
            if (sc.swiper && sc.swiper.update) sc.swiper.update();
            schedule(sec);
          }).observe(sc);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', function () {
    updateSwipers();
    fitAll();
    setTimeout(function () { updateSwipers(); fitAll(); }, 300);
  });
  window.addEventListener('resize', function () { updateSwipers(); fitAll(); });
})();
